import { Image, Link, Text, View } from '@react-pdf/renderer'

import { cn, fmtPhoneNumber } from '~/lib'
import type { Client } from '~/models'
import { tw } from '../tw'

export default function PdfClientBrokerProfile({
  orientation,
  client,
}: {
  orientation: 'portrait' | 'landscape'
  client: Client
}) {
  return (
    <View
      style={tw(
        cn(
          'w-1/3 bg-gray-100 p-8',
          orientation === 'portrait' ? 'h-[792px]' : 'h-[612px]'
        )
      )}>
      <View style={tw('flex flex-row justify-center')}>
        {client.logo ? (
          <Image style={tw('max-h-36 w-36 object-contain')} src={client.logo} />
        ) : (
          <View
            style={tw(
              'flex h-36 w-36 flex-row items-center justify-center rounded-full bg-white'
            )}>
            <Text style={tw('mt-2 text-2xl font-medium')}>{client.name}</Text>
          </View>
        )}
      </View>
      {client.contact && (
        <View style={tw('mt-8 flex flex-col gap-1')}>
          <View style={tw('flex flex-row')}>
            <Text style={tw('text-base font-bold')}>
              {`${client.contact?.name}`}
            </Text>
          </View>
          {client.contact?.title && (
            <Text style={tw('text-sm')}>{client.contact.title}</Text>
          )}
          {client.contact?.email && (
            <View style={tw('mt-1 flex flex-row')}>
              <Text style={tw('w-4 text-sm')}>E:</Text>
              <Link
                style={tw('text-sm text-primary no-underline')}
                href={`mailto:${client.contact.email}`}>
                {client.contact.email}
              </Link>
            </View>
          )}
          {client.contact?.phone && (
            <View style={tw('mt-1 flex flex-row')}>
              <Text style={tw('w-4 text-sm')}>O:</Text>
              <Link
                style={tw('text-sm text-primary no-underline')}
                href={`tel:${client.contact.phone}`}>
                {fmtPhoneNumber(client.contact.phone)}
              </Link>
            </View>
          )}
        </View>
      )}

      {/* {client && (
          <View style={tw('mt-8 border-t border-gray-300 pt-8')}>
            <View style={tw('flex flex-row justify-center gap-4')}>
              {client.meta.logo && (
                <Image
                  style={tw('h-36')}
                  src={transformImageUrl(client.meta.logo.url)}
                />
              )}
            </View>
            <Text style={tw('mt-2 font-sans text-base font-bold')}>
              {client.name}
            </Text>
            {client.meta.address && (
              <Text style={tw('text-base')}>{fmtAddress(client.meta)}</Text>
            )}
          </View>
        )} */}
    </View>
  )
}
